import * as React from "react";
import type { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
  isActive?: boolean;
  height?: number;
  width?: number;
}

export const WifiFillIcon = ({
  fill = "#6F747B",
  isActive,
  height = 24,
  width = 24,
  ...restProps
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 7 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 relative"
    {...restProps}
  >
    <path
      opacity="0.4"
      fill={fill}
      className={`dark:${
        isActive ? "fill-primary" : "fill-caption group-hover:dark:fill-primary"
      }`}
      d="M3.17551 0.168945C2.00374 0.168945 0.978447 0.668776 0.246094 1.45422L3.17551 4.92924L6.10492 1.45422C5.37256 0.668776 4.34727 0.168945 3.17551 0.168945Z"
    />
  </svg>
);
export default WifiFillIcon;
